import { httpClient } from '@/Common/api/http_client';

// =========================================
// Merchant Specific APIs starts
/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getAllPermissions() {
  return httpClient.get('/permissions');
}

/**
 *
 * @param permissionId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deletePermission(permissionId) {
  return httpClient.delete(`/permissions/${permissionId}`);
}

/**
 *
 * @param permissionId
 * @param permission
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updatePermission(permissionId, permission) {
  return httpClient.put(`/permissions/${permissionId}`, permission);
}

/**
 *
 * @param permission
 * @returns {Promise<AxiosResponse<T>>}
 */
export function newPermission(permission) {
  return httpClient.post('/permissions', permission);
}

// Merchant Specific APIs ends
// =========================================
